// extracted by mini-css-extract-plugin
export default {"toggle":"toggle--yrsgI8zB"};